import { render, staticRenderFns } from "./virtualcurrency-edit.vue?vue&type=template&id=4041af8b&"
import script from "./virtualcurrency-edit.vue?vue&type=script&lang=js&"
export * from "./virtualcurrency-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports